import { render, staticRenderFns } from "./RegistrationGiftPicker.vue?vue&type=template&id=973c1260&scoped=true"
import script from "./RegistrationGiftPicker.vue?vue&type=script&lang=js"
export * from "./RegistrationGiftPicker.vue?vue&type=script&lang=js"
import style0 from "./RegistrationGiftPicker.vue?vue&type=style&index=0&id=973c1260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973c1260",
  null
  
)

export default component.exports